export const SET_AVAILABLE_NODES = 'SET_AVAILABLE_NODES';
export const SET_AVAILABLE_TAGS = 'SET_AVAILABLE_TAGS';
export const SET_AVAILABLE_TEMPLATES = 'SET_AVAILABLE_TEMPLATES';
export const SET_AVAILABLE_VOICES = 'SET_AVAILABLE_VOICES';
export const SET_CALL_FLOW_TREES = 'SET_CALL_FLOW_TREES';
export const SET_CALL_FLOW_TREE = 'SET_CALL_FLOW_TREE';
export const SET_CALL_FLOW_TREE_REFERENCES = 'SET_CALL_FLOW_TREE_REFERENCES';
export const SET_CALL_FLOW_SCENE_ERRORS = 'SET_CALL_FLOW_SCENE_ERRORS';